import { render } from "./TarotHouseSpreadResults.vue?vue&type=template&id=92f32268&scoped=true"
const script = {}

import "./TarotHouseSpreadResults.vue?vue&type=style&index=0&id=92f32268&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f32268"]])

export default __exports__